import script from "./dailyTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./dailyTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./dailyTreasureView.vue?vue&type=style&index=0&id=0107c14e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0107c14e"]])

export default __exports__